import { useAtom } from "jotai";
import { DialogHandlerStore } from "../stores/dialog-handler-store";

export function useDialogHandler(params?: { dialogComponent?: JSX.Element }) {
  const [dialogHandlerState, setDialogHandlerState] = useAtom(DialogHandlerStore);

  return {
    isOpen: dialogHandlerState.isOpen,
    openDialog,
    closeDialog,
  };

  function openDialog() {
    setDialogHandlerState({ isOpen: true, ...params });
  }

  function closeDialog() {
    setDialogHandlerState({ isOpen: false });
  }
}
